import { render, staticRenderFns } from "./assessmentRecord.vue?vue&type=template&id=78647d80&scoped=true&"
import script from "./assessmentRecord.vue?vue&type=script&lang=js&"
export * from "./assessmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./assessmentRecord.vue?vue&type=style&index=0&id=78647d80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78647d80",
  null
  
)

export default component.exports